<template>
  <Fragment>
    <template>
      <div id="ruleImg">
        <img :src="banners" />
      </div>
    </template>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import ruleImg from "@/assets/images/flow.jpg";

export default {
  name: "productCodeRule",
  components: {
    Fragment
  },
  data() {
    return {
      banners: ruleImg
    };
  }
};
</script>
